import React from "react";
import moment from "moment";
import NumberUtils from "util/NumberUtils";
const DetailsCell = ({ details }) => {
  const trafficLimit = NumberUtils.formatBytes(details.traffic_limit);
  const trafficCheckRange = moment.duration(details.traffic_check_range);
  const expirationWarning = moment.duration(details.expiration_warning_range);
  const versionDetails = () => {
    switch (details.version) {
      case 1:
        return /* @__PURE__ */ React.createElement("p", null, "Maximum nodes in cluster: ", details.number_of_nodes);
      case 2:
      case 4:
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "Daily traffic limit: ", trafficLimit, " (allowed violations per ", trafficCheckRange.as("days"), " days:", " ", details.allowed_traffic_violations, ")"), /* @__PURE__ */ React.createElement("p", null, "Requires remote checks: ", details.require_remote_check ? "Yes" : "No", details.require_remote_check && ` (allowed consecutive check failures: ${details.allowed_remote_check_failures})`), /* @__PURE__ */ React.createElement("p", null, "License expiration warning: ", expirationWarning.as("days"), " days before"));
      case 3:
        if (!details.traffic_limit) {
          return null;
        }
        return /* @__PURE__ */ React.createElement("p", null, "Remaining Provision: ", trafficLimit);
      default:
        return /* @__PURE__ */ React.createElement("p", null, "Unknown license version, cannot display details.");
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, details.trial && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "Trial License")), versionDetails());
};
export default DetailsCell;
